import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { AuthTokenProvider } from './auth';
import {
  installAxiosAuthInterceptors,
  bindAuthUserIdGetter,
  bindRememberMeGetter,
} from './auth/httpClient';
import { accessTokenStore } from './auth/accessTokenStore';
import { shouldPersistAccessToken } from './auth/tokenPersist';
import i18n from './i18n';
import './index.css';
import App from './App';

// Bind before any route effect fires so reload silent-refresh sees rememberMe/userId.
installAxiosAuthInterceptors();
bindAuthUserIdGetter(() => store.getState().auth.user?.userId ?? null);
bindRememberMeGetter(() => store.getState().auth.rememberMe);

// Short session: put tab-memory JWT back before first API call.
if (
  store.getState().auth.isAuthenticated &&
  shouldPersistAccessToken(store.getState().auth.rememberMe)
) {
  accessTokenStore.restoreFromSession();
}

// Align i18n with Redux persisted language before any route renders (login cold-load).
const selected = store.getState().language?.selected;
if ((selected === 'en' || selected === 'zh') && i18n.language !== selected) {
  void i18n.changeLanguage(selected);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>     //temporarily removed to prevent double API calls
    <Provider store={store}>
      <BrowserRouter>
        <AuthTokenProvider>
          <App />
        </AuthTokenProvider>
      </BrowserRouter>
    </Provider>
  //</React.StrictMode>
);
